import { TaskType } from '@prisma/client';
import { BaseModelInternalId } from '@scale/llm-shared/modelProviders/types';

export const DEFAULT_TASK_TYPE = TaskType.Classification;

export const ACCEPTED_FILE_EXTS = ['.csv', '.jsonl'] as const;

export type AcceptedFileExt = typeof ACCEPTED_FILE_EXTS[number];
